import { calculatePaginationOffset, compareValues, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
export const licensesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getLicenses: build.query({
            // matchFulfilled only fires on real fetches, not cache hits. Without keepUnusedDataFor=0,
            // extraReducer matchers (e.g. auto-expand on single-match filters) silently
            // skip on re-navigation because RTK Query serves cached data instead of fetching.
            keepUnusedDataFor: 0,
            query: (queryArg) => ({
                url: `${REPORTS_ENDPOINT}/${queryArg.ui_id}/licenses`,
                params: {
                    policy_id: queryArg.filter.policy_id,
                    license_family: queryArg.filter.license_family,
                    only_violations: queryArg.filter.only_violations,
                    limit: queryArg.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(queryArg.pagination),
                    sort_by: convertSortToQueryString(queryArg.sort),
                },
            }),
        }),
        getLicenseDetails: build.query({
            query: (queryArg) => ({
                url: `${REPORTS_ENDPOINT}/${queryArg.ui_id}/licenses/${queryArg.ui_item_id}/details`,
            }),
        }),
        getLicenseReferences: build.query({
            query: (queryArg) => ({
                url: `${REPORTS_ENDPOINT}/${queryArg.ui_id}/licenses/${queryArg.ui_item_id}/references`,
                params: {
                    limit: queryArg.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(queryArg.pagination),
                },
            }),
        }),
        getLicensePolicies: build.query({
            query: (queryArg) => ({
                url: `${REPORTS_ENDPOINT}/${queryArg.ui_id}/licenses/policies`,
            }),
            transformResponse: (queryArg) => {
                return queryArg.sort((first, second) => compareValues(first.id, second.id, false));
            },
        }),
    }),
    overrideExisting: false,
});
export const { useGetLicensesQuery, useGetLicenseDetailsQuery, useGetLicenseReferencesQuery, useLazyGetLicensePoliciesQuery, } = licensesApi;
//# sourceMappingURL=licenses.api.js.map